import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import { isValidCategory } from "./is-valid-category";

export function getValidCategory(product: ICompactProduct) {
  const { primaryCategory, category } = product;
  if (isValidCategory(primaryCategory)) {
    return { ...primaryCategory };
  } if (isValidCategory(category)) {
    return { ...category };
  }
  return {};
}
